import { useEffect, useState } from 'react';

export type Size = 'sm' | 'md' | 'lg' | 'xl' | 'xxl';

export const useScreenSize = () => {
  const [screenSize, setScreenSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    function handleResize() {
      setScreenSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }

    window.addEventListener('resize', handleResize);

    // Cleanup the event listener on component unmount
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // breakpoints
  const isSmallScreen = screenSize.width < 768; // tailwind 'sm' breakpoint
  const isMediumScreen = screenSize.width >= 768 && screenSize.width < 1024; // tailwind 'md' to 'lg' range
  const isLargeScreen = screenSize.width >= 1024 && screenSize.width < 1440; // tailwind 'lg' to 'xl range
  const isExtraLargeScreen = screenSize.width >= 1440 && screenSize.width < 2560; // tailwind 'xl' to '2xl' range
  const isDoubleExtraLargeScreen = screenSize.width >= 2560; // tailwind '2xl' breakpoint and above

  const getSize: Size = (() => {
    if (isDoubleExtraLargeScreen) return 'xxl';
    if (isExtraLargeScreen) return 'xl';
    if (isLargeScreen) return 'lg';
    if (isMediumScreen) return 'md';
    if (isSmallScreen) return 'sm';
    return 'md';
  })();

  return {
    screenSize,
    isSmallScreen,
    isMediumScreen,
    isLargeScreen,
    isExtraLargeScreen,
    isDoubleExtraLargeScreen,
    getSize,
  };
};
